/** QA order exclusion only. Ordinary visits make no requests; existing tracking is unchanged. */
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script || window.__palermoOrderQaLoaded) return;
  window.__palermoOrderQaLoaded = true;
  var KEY = 'palermo_order_qa';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var qa = false, busy = false, saved = false, failures = 0, retryTimer = null;

  function remember() {
    qa = true;
    try { document.cookie = KEY + '=1; path=/; max-age=2592000; SameSite=Lax; Secure'; } catch (e) {}
    try {
      if (Number(window.localStorage.getItem(KEY)) <= Date.now()) {
        window.localStorage.setItem(KEY, String(Date.now() + 2592000000));
      }
    } catch (e) {}
  }
  function detect() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('palermo_tracking_qa') === '1' ||
          ['preview_theme_id', 'sale_filters_preview', 'pdp_template_preview', 'gb_force', 'gbForce', 'gbForceVariations'].some(function (key) { return params.has(key); }) ||
          Array.from(params.keys()).some(function (key) { return key.indexOf('gb~') === 0 || key.indexOf('gbfeat~') === 0; }) ||
          script.getAttribute('data-design-mode') === 'true' ||
          (window.Shopify && (window.Shopify.designMode || (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main'))) ||
          /(?:^|;\s*)palermo_order_qa=1(?:;|$)/.test(document.cookie)) remember();
    } catch (e) { /* Do not classify ordinary traffic as QA on an API error. */ }
    try { if (Number(window.localStorage.getItem(KEY)) > Date.now()) remember(); } catch (e) {}
    return qa;
  }
  function status(value) { script.setAttribute('data-sync-status', value); }
  function sync() {
    if (!detect()) { status('ordinary'); return; }
    if (busy || saved) return;
    busy = true; status('saving');
    Promise.resolve().then(function () {
      return window.fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // Never write 0: another tab can only add the exclusion, never clear it.
        body: JSON.stringify({ attributes: { palermo_tracking_qa: '1' } })
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_write_failed');
      return response.json();
    }).then(function (cart) {
      if (!cart.attributes || cart.attributes.palermo_tracking_qa !== '1') throw new Error('cart_write_unconfirmed');
      saved = true; failures = 0; status('excluded');
    }).catch(function () {
      status('error');
      if (++failures <= 3 && !retryTimer) {
        retryTimer = setTimeout(function () { retryTimer = null; sync(); }, failures * 1000);
      }
    }).finally(function () { busy = false; });
  }
  window.addEventListener('storage', function (event) {
    if (event.key === KEY && Number(event.newValue) > Date.now()) { remember(); sync(); }
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { saved = false; failures = 0; sync(); }
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { failures = 0; sync(); }
  });
  sync();
})();
